export default "__VITE_PUBLIC_ASSET__1c472379__"